<div
  class="overflow-hidden rounded-2xl border border-slate-200 bg-white"
  [attr.data-testid]="
    'document-month-group-' + (month().year ?? 'null') + '-' + (month().month ?? 'null')
  "
>
  <!-- Month header -->
  <div
    class="flex cursor-pointer select-none items-center justify-between gap-3 px-5 py-4 transition-colors hover:bg-slate-50"
    data-testid="document-month-group-header"
    (click)="onToggle()"
  >
    <div class="flex items-center gap-3">
      <i
        class="pi text-slate-400 transition-transform duration-200"
        [class]="isOpen() ? 'pi-chevron-down' : 'pi-chevron-right'"
      ></i>
      <span class="text-base font-semibold text-slate-800">{{ month().label }}</span>
      <span class="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500">{{
        count()
      }}</span>
      @if (attentionCount() > 0) {
        <span
          class="rounded-full bg-rose-50 px-2 py-0.5 text-xs font-semibold text-rose-600 ring-1 ring-rose-100"
        >
          {{
            'common.documents.monthGroup.attentionCount' | translate: { count: attentionCount() }
          }}
        </span>
      }
    </div>
    <div class="flex items-center gap-4">
      @if (totalAmount() !== undefined) {
        <span class="font-mono text-sm font-semibold text-slate-700">
          {{ totalAmount() | number: '1.2-2' }} {{ currency() }}
        </span>
      }
      <p-button
        [label]="'common.documents.monthGroup.export' | translate"
        icon="pi pi-download"
        severity="secondary"
        size="small"
        [text]="true"
        data-testid="document-month-group-export-button"
        (onClick)="onExport($event)"
      />
    </div>
  </div>

  <!-- Content -->
  @if (isOpen()) {
    <div class="border-t border-slate-100">
      @if (isLoading()) {
        <div class="flex flex-col gap-px p-4">
          <p-skeleton height="48px" styleClass="rounded-lg" />
          <p-skeleton height="48px" styleClass="rounded-lg" />
          <p-skeleton height="48px" styleClass="rounded-lg" />
        </div>
      } @else if (hasError()) {
        <div class="flex items-center gap-3 px-5 py-4 text-sm text-red-600">
          <i class="pi pi-exclamation-circle"></i>
          <span>{{ 'common.documents.monthGroup.loadError' | translate }}</span>
          <button class="ml-auto text-xs font-medium underline" (click)="expand.emit(month())">
            {{ 'common.documents.monthGroup.retry' | translate }}
          </button>
        </div>
      } @else if (documents().length === 0) {
        <div class="px-5 py-10 text-center text-sm text-slate-400">
          <i class="pi pi-folder-open mb-2 block text-2xl"></i>
          {{ 'common.documents.monthGroup.empty' | translate }}
        </div>
      } @else {
        <!-- Column headers -->
        <div
          class="grid grid-cols-[2fr_1fr_1fr_1fr_1fr_auto] items-center gap-2 border-b border-slate-100 bg-slate-50 px-5 py-2"
        >
          <span class="text-xs font-semibold uppercase tracking-wider text-slate-400">{{
            'common.documents.monthGroup.columns.document' | translate
          }}</span>
          <span class="text-xs font-semibold uppercase tracking-wider text-slate-400">{{
            'common.documents.monthGroup.columns.type' | translate
          }}</span>
          <span class="text-xs font-semibold uppercase tracking-wider text-slate-400">{{
            'common.documents.monthGroup.columns.supplier' | translate
          }}</span>
          <span class="text-right text-xs font-semibold uppercase tracking-wider text-slate-400">{{
            'common.documents.monthGroup.columns.amountDate' | translate
          }}</span>
          <span class="text-xs font-semibold uppercase tracking-wider text-slate-400">{{
            'common.documents.monthGroup.columns.status' | translate
          }}</span>
          <span class="w-8"></span>
        </div>
        <!-- Rows -->
        <div class="divide-y divide-slate-100">
          @for (doc of documents(); track doc.id) {
            <lib-document-row
              [document]="doc"
              (rowClick)="onDocumentClick($event)"
              (downloadClick)="onDocumentDownload($event)"
            />
          }
        </div>
      }
    </div>
  }
</div>
